import "./LetsTalkSafety.module.css";
import Header from "@/reusable_sections/Header";
import ProjectInquiry from "./sections/ProjectInquiry";
import LogisticsFaq from "./sections/LogisticsFaq";
import Footer from "@/reusable_sections/Footer";
export default function LetsTalkSafetyPage() {
  return <div>
      <Header />
      <ProjectInquiry />
      <LogisticsFaq />
      <Footer />
    </div>;
}